import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class CompletedInfo extends Component {

  render() {

    let CustomClass = this.props.customClass ? this.props.customClass : ''

    let publicUrl = process.env.PUBLIC_URL + '/'

    return <div className={"ltn__apartments-plan-area pt-115--- pb-70 " + CustomClass}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title-area ltn__section-title-2--- text-center">
              {/* <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">Apartment Sketch</h6> */}
              <h1 className="section-title">Completed Properties</h1>
            </div>
            <div className="ltn__tab-menu ltn__tab-menu-3 ltn__tab-menu-top-right-- text-uppercase--- text-center">
              <div className="nav">
                <a data-bs-toggle="tab" href="#liton_tab_3_1">Manimangalam</a>
                <a data-bs-toggle="tab" href="#liton_tab_3_2">Chengalpattu</a>
                {/* className="active show"  */}
                <a data-bs-toggle="tab" href="#liton_tab_3_3">Guduvancheri</a>
                <a data-bs-toggle="tab" href="#liton_tab_3_4">Oragadam</a>
                        {/* <a data-bs-toggle="tab" href="#liton_tab_3_5">Double Height</a> */}
              </div>
            </div>
            <div className="tab-content">
              <div className="tab-pane fade" id="liton_tab_3_1">
                <div className="ltn__apartments-tab-content-inner">
                  <div className="row">
                    <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <img src={publicUrl + "assets/img/projects/Ganesh Nagar/img2.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot: 58</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Malai Pattu</h6>
                            <h4>Ganesh Nagar</h4>
                            <div className="search-by-place-btn">
                              <Link to="/manimangalam-01">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                           <img src={publicUrl + "assets/img/projects/Krishna Nagar/img1.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plots:4</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Navallur</h6>
                            <h4>Krishna Nagar</h4>
                            <div className="search-by-place-btn">
                              <Link to="/manimangalam-02">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                           <img src={publicUrl + "assets/img/projects/Manimozhi nagar/img1.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot:10</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Naduveera Pattu</h6>
                            <h4>Manimozhi Nagar</h4>
                            <div className="search-by-place-btn">
                              <Link to="/manimangalam-03">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade active show" id="liton_tab_3_2">
                <div className="ltn__product-tab-content-inner">
                  <div className="row">
                    <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <img src={publicUrl + "assets/img/projects/Collector Nagar/img1.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot: 58</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Chengalpattu</h6>
                            <h4>Collector Nagar</h4>
                            <div className="search-by-place-btn">
                              <Link to="/cheng-01">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <img src={publicUrl + "assets/img/projects/Dhanu/img1.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plots:4</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Chengalpattu</h6>
                            <h4>Dhanushree Mount View</h4>
                            <div className="search-by-place-btn">
                              <Link to="/cheng-02">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <img src={publicUrl + "assets/img/projects/KKR City/img1.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot:10</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Chengalpattu</h6>
                            <h4>KKR City</h4>
                            <div className="search-by-place-btn">
                              <Link to="/cheng-03">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade" id="liton_tab_3_3">
                <div className="ltn__product-tab-content-inner">
                  <div className="row">
                    <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <img src={publicUrl + "assets/img/projects/GE/img2.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot: 58</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Guduvancheri</h6>
                            <h4>GE Avenue</h4>
                            <div className="search-by-place-btn">
                              <Link to="/gudu-01">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <img src={publicUrl + "assets/img/projects/Lake/img3.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plots:4</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Guduvancheri</h6>
                            <h4>Lake Down Avenue</h4>
                            <div className="search-by-place-btn">
                              <Link to="/gudu-02">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <img src={publicUrl + "assets/img/projects/Rithika/img1.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot:10</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Guduvancheri</h6>
                            <h4>Rithika Enclave</h4>
                            <div className="search-by-place-btn">
                              <Link to="/gudu-03">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade" id="liton_tab_3_4">
                <div className="ltn__product-tab-content-inner">
                  <div className="row">
                    <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <img src={publicUrl + "assets/img/projects/Globalcity/img1.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot: 58</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Oragadam</h6>
                            <h4>Global City</h4>
                            <div className="search-by-place-btn">
                              <Link to="/orag-01">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <img src={publicUrl + "assets/img/projects/Zion Garden/img1.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plots:4</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Padappai</h6>
                            <h4>Zion Garden</h4>
                            <div className="search-by-place-btn">
                              <Link to="/orag-02">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                           <img src={publicUrl + "assets/img/projects/sumathi/img1.jpg"} alt="#" />
                            {/* <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot:10</li>
                              </ul>
                            </div> */}
                          </div>
                          <div className="search-by-place-info">
                            <h6>Kunnavakkam </h6>
                            <h4>Sumathi Ammal Nagar</h4>
                            <div className="search-by-place-btn">
                              <Link to="/orag-03">View Projects <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export default CompletedInfo